// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  parcelId: __t.u64().primaryKey().name("parcel_id"),
  contractId: __t.u64().name("contract_id"),
  issuer: __t.identity(),
  taker: __t.identity(),
  recipient: __t.identity(),
  kind: __t.string(),
  itemKey: __t.string().name("item_key"),
  name: __t.string(),
  qty: __t.u32(),
  packedJson: __t.string().name("packed_json"),
  holder: __t.string(),
});
